export default "__VITE_ASSET__DdaMEBvQ__"